export default "__VITE_ASSET__Ctn8CBbK__"